import 'css-chunksrc/client/pages/documentsPage/reportsPage/filterForm/resourcesFilter/resource/styles.scss';export default {
  "resource": "_resource_824k9_1",
  "avatar": "_avatar_824k9_9",
  "name": "_name_824k9_16"
};